// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Tag,
//   Button,
//   Space,
//   Image,
//   Modal,
//   message,
//   Spin,
//   Card,
//   Layout,
//   Typography
// } from "antd";
// import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../Config";
// import Sidebar from "../Components/Sidebar";

// import { MenuOutlined } from "@ant-design/icons";

// const { Header, Content } = Layout;
// const { Title, Paragraph, Text } = Typography;

// const AdminMediaLink = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const [viewOpen, setViewOpen] = useState(false);
//   const [images, setImages] = useState([]);
//   const [imageLoading, setImageLoading] = useState(false);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const [filter, setFilter] = useState("pending"); // pending | approved

//   const token = sessionStorage.getItem("token");

//   useEffect(() => {
//     fetchPromotionRequests(filter);
//   }, [filter]);

//   const fetchPromotionRequests = async (selectedFilter = filter) => {
//     try {
//       setLoading(true);

//       const url =
//   selectedFilter === "paid"
//     ? `${BASE_URL}/promoteimgs?type=paid`
//     : selectedFilter === "pending"
//     ? `${BASE_URL}/promoteimgs?type=promotion_pending`
//     : `${BASE_URL}/promoteimgs`;

//       const res = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setData(res.data?.data || []);
//     } catch (err) {
//       message.error("Failed to load data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleViewImages = async (id) => {
//     try {
//       setViewOpen(true);
//       setImageLoading(true);

//       const res = await axios.get(`${BASE_URL}/promoteimgs/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setImages(res.data.data?.promotionImgs || []);
//     } catch (err) {
//       message.error("Failed to load images");
//     } finally {
//       setImageLoading(false);
//     }
//   };

//   const handleApprove = async (id) => {
//     try {
//       await axios.put(
//         `${BASE_URL}/promoteimgs/promotion-approve/${id}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       message.success("Promotion approved");
//       fetchPromotionRequests();
//     } catch (err) {
//       message.error("Approval failed");
//     }
//   };

//   const handleReject = async (id) => {
//     try {
//       await axios.put(
//         `${BASE_URL}/promoteimgs/promotion-reject/${id}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } },
//       );

//       message.success("Promotion rejected");
//       fetchPromotionRequests();
//     } catch (err) {
//       message.error("Rejection failed");
//     }
//   };

//   const filteredData =
//     filter === "paid"
//       ? data
//       : data.filter((item) => {
//         if (filter === "pending")
//           return item.mediaLinkAction === "promotion_pending";

//         if (filter === "approved")
//           return item.mediaLinkAction === "completed";

//         return true;
//       });

//   const columns = [
//     {
//       title: "Variation",
//       dataIndex: "name",
//       render: (text) => <strong>{text}</strong>,
//     },
//     {
//       title: "Asana",
//       dataIndex: ["parentAsana", "name"],
//     },
//     {
//       title: "User",
//       render: (_, record) => (
//         <>
//           <div>{record.user?.name}</div>
//           <small style={{ color: "#888" }}>{record.user?.email}</small>
//         </>
//       ),
//     },
//     {
//       title: "Pose Type",
//       dataIndex: "poseType",
//       render: (types) =>
//         types?.map((t, i) => (
//           <Tag color="blue" key={i}>
//             {t}
//           </Tag>
//         )),
//     },
//     {
//       title: "Status",
//       dataIndex: "mediaLinkAction",
//       render: (status) => {
//         if (status === "promotion_pending") {
//           return <Tag color="orange">Promotion Pending</Tag>;
//         }
//         if (status === "completed") {
//           return <Tag color="green">Approved</Tag>;
//         }
//         return <Tag>—</Tag>;
//       },
//     },
//     {
//       title: "Images",
//       render: (_, record) => (
//         <Button
//           icon={<EyeOutlined />}
//           onClick={() => handleViewImages(record._id)}
//         >
//           View
//         </Button>
//       ),
//     },
//     {
//       title: "Actions",
//       render: (_, record) => {
//         if (filter === "paid") {
//           return <Tag color="blue">Paid User</Tag>;
//         }

//         const isPending = record.mediaLinkAction === "promotion_pending";

//         return (
//           <Space>
//             {isPending ? (
//               <>
//                 <Button
//                   type="primary"
//                   icon={<CheckOutlined />}
//                   onClick={() => handleApprove(record._id)}
//                 >
//                   Approve
//                 </Button>

//                 <Button
//                   danger
//                   icon={<CloseOutlined />}
//                   onClick={() => handleReject(record._id)}
//                 >
//                   Reject
//                 </Button>
//               </>
//             ) : (
//               <Tag color="green">Completed</Tag>
//             )}
//           </Space>
//         );
//       },
//     },
//   ];

//   const MobilePromotionCard = ({ item }) => {

//     const isApproved =
//       item.mediaLinkAction === "completed";

//     const isPending =
//       item.mediaLinkAction === "promotion_pending";

//     return (

//       <Card
//         style={{
//           marginBottom: 16,
//           borderRadius: 18,
//         }}
//         bodyStyle={{
//           padding: 14,
//         }}
//       >

//         {/* Top Row */}

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >

//           <Space>

//             <Image
//               src={item.image}
//               width={60}
//               height={60}
//               style={{
//                 borderRadius: 12,
//                 objectFit: "cover",
//               }}
//             />

//             <div>

//               <div
//                 style={{
//                   fontWeight: 600,
//                   fontSize: 16,
//                 }}
//               >
//                 {item.name}
//               </div>

//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#777",
//                 }}
//               >
//                 {item.poseType?.join(", ")}
//               </div>

//             </div>

//           </Space>


//           {/* Status */}

//           <Tag
//             color="green"
//             style={{
//               borderRadius: 20,
//               padding: "4px 14px",
//             }}
//           >
//             {isApproved
//               ? "APPROVED"
//               : "PENDING"}
//           </Tag>

//         </div>


//         {/* Media Link Status */}

//         <div style={{ marginTop: 10 }}>

//           <Tag color="blue">
//             {item.mediaLinkStatus || "expired"}
//           </Tag>

//         </div>


//         {/* Actions */}

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 10,
//             marginTop: 14,
//           }}
//         >

//           <Button
//             icon={<EyeOutlined />}
//             shape="round"
//             onClick={() =>
//               handleViewImages(item._id)
//             }
//           />

//           {isPending && (

//             <>
//               <Button
//                 icon={<CheckOutlined />}
//                 type="primary"
//                 shape="round"
//                 style={{
//                   background: "#10b981",
//                   borderColor: "#10b981",
//                 }}
//                 onClick={() =>
//                   handleApprove(item._id)
//                 }
//               />

//               <Button
//                 icon={<CloseOutlined />}
//                 danger
//                 shape="round"
//                 onClick={() =>
//                   handleReject(item._id)
//                 }
//               />

//             </>

//           )}

//         </div>

//       </Card>

//     );
//   };

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="admin"
//       />
//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>
//               <Header
//                 className="MainHeader"
//               >
//                 {isMobile && (
//                   <Button
//                     type="text"
//                     icon={<MenuOutlined />}
//                     onClick={() => setMobileOpen(true)}
//                     style={{ fontSize: 18, marginRight: 12 }}
//                   />
//                 )}
//                 <div style={{ flex: 1 }}>
//                   <Text style={{ fontSize: 20, fontWeight: "bold" }}>Media Link</Text>
//                 </div>
//               </Header>
//             </Text>
//           </div>
//         </Header>
//         <Card
//           title="Media Link status"
//           extra={
//             isMobile ? (
//               <div style={{ display: "flex", justifyContent: "center" }}>
//                 <Button
//                   type={filter === "pending" ? "primary" : "default"}
//                   onClick={() => setFilter("pending")}
//                 >
//                   Pending
//                 </Button>

//                 <Button
//                   type={filter === "approved" ? "primary" : "default"}
//                   onClick={() => setFilter("approved")}
//                 >
//                   Approved
//                 </Button>

//                 <Button
//                   type={filter === "paid" ? "primary" : "default"}
//                   onClick={() => setFilter("paid")}
//                 >
//                   Paid Variations
//                 </Button>
//               </div>
//             ) : (

//               <Space>
//                 <Button
//                   type={filter === "pending" ? "primary" : "default"}
//                   onClick={() => setFilter("pending")}
//                 >
//                   Pending
//                 </Button>

//                 <Button
//                   type={filter === "approved" ? "primary" : "default"}
//                   onClick={() => setFilter("approved")}
//                 >
//                   Approved
//                 </Button>

//                 <Button
//                   type={filter === "paid" ? "primary" : "default"}
//                   onClick={() => setFilter("paid")}
//                 >
//                   Paid Variations
//                 </Button>
//               </Space>
//             )
//           }
//         >
//           {
//             isMobile ? (

//               loading ? (
//                 <Spin />
//               ) : (

//                 filteredData.map(item => (
//                   <MobilePromotionCard
//                     key={item._id}
//                     item={item}
//                   />
//                 ))

//               )

//             ) : (

//               <Table
//                 columns={columns}
//                 dataSource={filteredData}
//                 rowKey="_id"
//                 loading={loading}
//                 pagination={{ pageSize: 5 }}
//               />

//             )
//           }
//         </Card>

//         <Modal
//           title="Promotion Images"
//           open={viewOpen}
//           onCancel={() => setViewOpen(false)}
//           footer={null}
//           width={800}
//           centered
//         >
//           {imageLoading ? (
//             <Spin />
//           ) : (
//             <Space wrap>
//               {images.length ? (
//                 images.map((img, i) => (
//                   <Image
//                     key={i}
//                     src={img}
//                     width={200}
//                     style={{ borderRadius: 8 }}
//                   />
//                 ))
//               ) : (
//                 <p>No images found</p>
//               )}
//             </Space>
//           )}
//         </Modal>
//       </Layout>
//     </Layout>
//   );
// };

// export default AdminMediaLink;

import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Button,
  Space,
  Image,
  Modal,
  message,
  Spin,
  Card,
  Layout,
  Typography,
  Radio,
  Divider,
  Row,
  Col,
  Descriptions,
} from "antd";
import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../Config";
import Sidebar from "../Components/Sidebar";
import { MenuOutlined } from "@ant-design/icons";

const { Header } = Layout;
const { Text } = Typography;

// ─── Plan data matching the Free Extension Plans document ───────────────────

const PLANS = [
  {
    key: "basic1",
    label: "Basic - 1",
    description: "1 social media post about yogarefer.com",
    extensions: {
      p1: { mediaOnly: "1 month",   withLogo: "15 days" },
      p2: { mediaOnly: "15 days",   withLogo: "10 days" },
      p3: { mediaOnly: "10 days",   withLogo: "5 days"  },
      p4: { mediaOnly: "5 days",    withLogo: "3 days"  },
    },
  },
  {
    key: "basic2",
    label: "Basic - 2",
    description: "Share on 3 platforms about yogarefer.com",
    extensions: {
      p1: { mediaOnly: "3 months",  withLogo: "45 days" },
      p2: { mediaOnly: "45 days",   withLogo: "30 days" },
      p3: { mediaOnly: "30 days",   withLogo: "20 days" },
      p4: { mediaOnly: "15 days",   withLogo: "10 days" },
    },
  },
  {
    key: "standard",
    label: "Standard",
    description: "Share on 6 platforms about yogarefer.com",
    extensions: {
      p1: { mediaOnly: "6 months",  withLogo: "3 months" },
      p2: { mediaOnly: "3 months",  withLogo: "45 days"  },
      p3: { mediaOnly: "2 months",  withLogo: "45 days"  },
      p4: { mediaOnly: "1 month",   withLogo: "20 days"  },
    },
  },
  {
    key: "premium",
    label: "Premium",
    description: "Write a blog/review + share on 6 platforms + share in yoga groups",
    extensions: {
      p1: { mediaOnly: "12 months", withLogo: "6 months" },
      p2: { mediaOnly: "6 months",  withLogo: "3 months" },
      p3: { mediaOnly: "4 months",  withLogo: "2 months" },
      p4: { mediaOnly: "2 months",  withLogo: "1 month"  },
    },
  },
];

const LINK_COUNTS = [
  { key: "p1", label: "≤ 20 links" },
  { key: "p2", label: "≤ 50 links" },
  { key: "p3", label: "≤ 100 links" },
  { key: "p4", label: "≤ 200 links" },
];

// ─── Component ───────────────────────────────────────────────────────────────

const AdminMediaLink = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [viewOpen, setViewOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);

  // Plan-selection modal state
  const [planModalOpen, setPlanModalOpen] = useState(false);
  const [pendingRecord, setPendingRecord] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedLinkCount, setSelectedLinkCount] = useState(null);
  const [approving, setApproving] = useState(false);

  const [filter, setFilter] = useState("pending");
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    fetchPromotionRequests(filter);
  }, [filter]);

  const fetchPromotionRequests = async (selectedFilter = filter) => {
    try {
      setLoading(true);
      const url =
        selectedFilter === "paid"
          ? `${BASE_URL}/promoteimgs?type=paid`
          : selectedFilter === "pending"
          ? `${BASE_URL}/promoteimgs?type=promotion_pending`
          : `${BASE_URL}/promoteimgs`;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data?.data || []);
    } catch {
      message.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const handleViewImages = async (id) => {
    try {
      setViewOpen(true);
      setImageLoading(true);
      const res = await axios.get(`${BASE_URL}/promoteimgs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setImages(res.data.data?.promotionImgs || []);
    } catch {
      message.error("Failed to load images");
    } finally {
      setImageLoading(false);
    }
  };

  // Opens the plan-selection modal instead of approving directly
  const openPlanModal = (record) => {
    setPendingRecord(record);
    setSelectedPlan(null);
    setSelectedLinkCount(null);
    setPlanModalOpen(true);
  };

  const closePlanModal = () => {
    setPlanModalOpen(false);
    setPendingRecord(null);
    setSelectedPlan(null);
    setSelectedLinkCount(null);
  };

  // Called when admin confirms the plan selection
  const handleApproveWithPlan = async () => {
    if (!selectedPlan || !selectedLinkCount) {
      message.warning("Please select both a plan and link count");
      return;
    }

    try {
      setApproving(true);

      const planData = PLANS.find((p) => p.key === selectedPlan);
      const ext = planData?.extensions[selectedLinkCount];

      await axios.put(
        `${BASE_URL}/promoteimgs/promotion-approve/${pendingRecord._id}`,
        {
          plan: selectedPlan,           // e.g. "basic1"
          linkCountTier: selectedLinkCount, // e.g. "p2"
          extensionMediaOnly: ext?.mediaOnly,
          extensionWithLogo: ext?.withLogo,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      message.success(
        `Promotion approved — ${planData?.label} | Extension: ${ext?.mediaOnly} / ${ext?.withLogo}`
      );
      closePlanModal();
      fetchPromotionRequests();
    } catch {
      message.error("Approval failed");
    } finally {
      setApproving(false);
    }
  };

  const handleReject = async (id) => {
    try {
      await axios.put(
        `${BASE_URL}/promoteimgs/promotion-reject/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success("Promotion rejected");
      fetchPromotionRequests();
    } catch {
      message.error("Rejection failed");
    }
  };

  // Derived extension preview for the selected plan + count
  const extensionPreview = (() => {
    if (!selectedPlan || !selectedLinkCount) return null;
    const plan = PLANS.find((p) => p.key === selectedPlan);
    return plan?.extensions[selectedLinkCount] || null;
  })();

  const filteredData =
    filter === "paid"
      ? data
      : data.filter((item) => {
          if (filter === "pending") return item.mediaLinkAction === "promotion_pending";
          if (filter === "approved") return item.mediaLinkAction === "completed";
          return true;
        });

  const columns = [
    {
      title: "Variation",
      dataIndex: "name",
      render: (text) => <strong>{text}</strong>,
    },
    { title: "Asana", dataIndex: ["parentAsana", "name"] },
    {
      title: "User",
      render: (_, record) => (
        <>
          <div>{record.user?.name}</div>
          <small style={{ color: "#888" }}>{record.user?.email}</small>
        </>
      ),
    },
    {
      title: "Pose Type",
      dataIndex: "poseType",
      render: (types) =>
        types?.map((t, i) => (
          <Tag color="blue" key={i}>{t}</Tag>
        )),
    },
    {
      title: "Status",
      dataIndex: "mediaLinkAction",
      render: (status) => {
        if (status === "promotion_pending") return <Tag color="orange">Promotion Pending</Tag>;
        if (status === "completed") return <Tag color="green">Approved</Tag>;
        return <Tag>—</Tag>;
      },
    },
    {
      title: "Images",
      render: (_, record) => (
        <Button icon={<EyeOutlined />} onClick={() => handleViewImages(record._id)}>
          View
        </Button>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => {
        if (filter === "paid") return <Tag color="blue">Paid User</Tag>;
        const isPending = record.mediaLinkAction === "promotion_pending";
        return (
          <Space>
            {isPending ? (
              <>
                <Button
                  type="primary"
                  icon={<CheckOutlined />}
                  onClick={() => openPlanModal(record)}
                >
                  Approve
                </Button>
                <Button
                  danger
                  icon={<CloseOutlined />}
                  onClick={() => handleReject(record._id)}
                >
                  Reject
                </Button>
              </>
            ) : (
              <Tag color="green">Completed</Tag>
            )}
          </Space>
        );
      },
    },
  ];

  const MobilePromotionCard = ({ item }) => {
    const isApproved = item.mediaLinkAction === "completed";
    const isPending = item.mediaLinkAction === "promotion_pending";

    return (
      <Card style={{ marginBottom: 16, borderRadius: 18 }} bodyStyle={{ padding: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Space>
            <Image src={item.image} width={60} height={60} style={{ borderRadius: 12, objectFit: "cover" }} />
            <div>
              <div style={{ fontWeight: 600, fontSize: 16 }}>{item.name}</div>
              <div style={{ fontSize: 13, color: "#777" }}>{item.poseType?.join(", ")}</div>
            </div>
          </Space>
          <Tag color="green" style={{ borderRadius: 20, padding: "4px 14px" }}>
            {isApproved ? "APPROVED" : "PENDING"}
          </Tag>
        </div>
        <div style={{ marginTop: 10 }}>
          <Tag color="blue">{item.mediaLinkStatus || "expired"}</Tag>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 14 }}>
          <Button icon={<EyeOutlined />} shape="round" onClick={() => handleViewImages(item._id)} />
          {isPending && (
            <>
              <Button
                icon={<CheckOutlined />}
                type="primary"
                shape="round"
                style={{ background: "#10b981", borderColor: "#10b981" }}
                onClick={() => openPlanModal(item)}
              />
              <Button icon={<CloseOutlined />} danger shape="round" onClick={() => handleReject(item._id)} />
            </>
          )}
        </div>
      </Card>
    );
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />
      <Layout
        className="main-layout"
        style={{ marginLeft: isMobile ? 0 : collapsed ? 0 : 240, transition: "0.3s", padding: isMobile ? 10 : 20 }}
      >
        <Header className="MainHeader">
          {isMobile && (
            <Button type="text" icon={<MenuOutlined />} onClick={() => setMobileOpen(true)} style={{ fontSize: 18, marginRight: 12 }} />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>Media Link</Text>
          </div>
        </Header>

        <Card
          title="Media Link status"
          extra={
            <Space wrap>
              {["pending", "approved", "paid"].map((f) => (
                <Button key={f} type={filter === f ? "primary" : "default"} onClick={() => setFilter(f)}>
                  {f === "paid" ? "Paid Variations" : f.charAt(0).toUpperCase() + f.slice(1)}
                </Button>
              ))}
            </Space>
          }
        >
          {isMobile ? (
            loading ? <Spin /> : filteredData.map((item) => <MobilePromotionCard key={item._id} item={item} />)
          ) : (
            <Table columns={columns} dataSource={filteredData} rowKey="_id" loading={loading} pagination={{ pageSize: 5 }} />
          )}
        </Card>

        {/* ── View Images Modal ── */}
        <Modal title="Promotion Images" open={viewOpen} onCancel={() => setViewOpen(false)} footer={null} width={800} centered>
          {imageLoading ? <Spin /> : (
            <Space wrap>
              {images.length
                ? images.map((img, i) => <Image key={i} src={img} width={200} style={{ borderRadius: 8 }} />)
                : <p>No images found</p>}
            </Space>
          )}
        </Modal>

        {/* ── Plan Selection Modal ── */}
        <Modal
          title="Approve — Select Extension Plan"
          open={planModalOpen}
          onCancel={closePlanModal}
          width={620}
          centered
          footer={[
            <Button key="cancel" onClick={closePlanModal}>Cancel</Button>,
            <Button
              key="approve"
              type="primary"
              icon={<CheckOutlined />}
              loading={approving}
              disabled={!selectedPlan || !selectedLinkCount}
              onClick={handleApproveWithPlan}
            >
              Confirm Approval
            </Button>,
          ]}
        >
          {/* User summary */}
          {pendingRecord && (
            <Descriptions size="small" style={{ marginBottom: 16 }} column={isMobile ? 1 : 2}>
              <Descriptions.Item label="Variation"><strong>{pendingRecord.name}</strong></Descriptions.Item>
              <Descriptions.Item label="Asana">{pendingRecord.parentAsana?.name}</Descriptions.Item>
              <Descriptions.Item label="User">{pendingRecord.user?.name}</Descriptions.Item>
              <Descriptions.Item label="Email"><small>{pendingRecord.user?.email}</small></Descriptions.Item>
            </Descriptions>
          )}

          <Divider orientation="left" orientationMargin={0} style={{ fontSize: 13 }}>
            Step 1 — Select Plan
          </Divider>

          <Radio.Group
            value={selectedPlan}
            onChange={(e) => setSelectedPlan(e.target.value)}
            style={{ width: "100%" }}
          >
            <Row gutter={[10, 10]}>
              {PLANS.map((plan) => (
                <Col span={12} key={plan.key}>
                  <Radio.Button
                    value={plan.key}
                    style={{
                      width: "100%",
                      height: "auto",
                      padding: "10px 12px",
                      borderRadius: 8,
                      whiteSpace: "normal",
                      lineHeight: 1.4,
                      textAlign: "left",
                      display: "block",
                    }}
                  >
                    <div style={{ fontWeight: 600 }}>{plan.label}</div>
                    <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{plan.description}</div>
                  </Radio.Button>
                </Col>
              ))}
            </Row>
          </Radio.Group>

          <Divider orientation="left" orientationMargin={0} style={{ fontSize: 13, marginTop: 20 }}>
            Step 2 — User's Media Link Count
          </Divider>

          <Radio.Group
            value={selectedLinkCount}
            onChange={(e) => setSelectedLinkCount(e.target.value)}
            style={{ width: "100%" }}
          >
            <Row gutter={[10, 10]}>
              {LINK_COUNTS.map((lc) => (
                <Col span={6} key={lc.key}>
                  <Radio.Button
                    value={lc.key}
                    style={{
                      width: "100%",
                      textAlign: "center",
                      borderRadius: 8,
                      padding: "6px 0",
                      display: "block",
                    }}
                  >
                    {lc.label}
                  </Radio.Button>
                </Col>
              ))}
            </Row>
          </Radio.Group>

          {/* Extension preview */}
          {extensionPreview && (
            <>
              <Divider orientation="left" orientationMargin={0} style={{ fontSize: 13, marginTop: 20 }}>
                Extension Granted
              </Divider>
              <Row gutter={12}>
                <Col span={12}>
                  <Card
                    size="small"
                    style={{ background: "#f0fdf4", borderColor: "#86efac", borderRadius: 8 }}
                  >
                    <Text type="secondary" style={{ fontSize: 12 }}>Media link only</Text>
                    <div style={{ fontSize: 18, fontWeight: 700, color: "#16a34a" }}>
                      {extensionPreview.mediaOnly}
                    </div>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card
                    size="small"
                    style={{ background: "#eff6ff", borderColor: "#93c5fd", borderRadius: 8 }}
                  >
                    <Text type="secondary" style={{ fontSize: 12 }}>With logo</Text>
                    <div style={{ fontSize: 18, fontWeight: 700, color: "#2563eb" }}>
                      {extensionPreview.withLogo}
                    </div>
                  </Card>
                </Col>
              </Row>
              <Text type="secondary" style={{ fontSize: 11, display: "block", marginTop: 8 }}>
                * First duration = media link only · Second duration = media link with logo
              </Text>
            </>
          )}
        </Modal>
      </Layout>
    </Layout>
  );
};

export default AdminMediaLink;